const HistoryWrapper =() => {

    return(
        <>
            <div className="historywrapper history_wrapper_container">
                <div className="history_wrapper_content">
                    <div className="history_wrapper_head">
                        
                        <h1>HistoryWrapper</h1>
                    </div>
                    <div className="history_wrapper_body">
                        
                        <h2>body</h2>
                    </div>
                    <div className="history_wrapper_footer">
                        
                        <h2>footer</h2>
                    </div>
                </div>
            </div>
        </>
    )
}
export default HistoryWrapper;